<template>
	<div class="home-background">
		<div class="home-title">
			<div class="title-left">
				<img style="width: 21px; height: 21px;" src="@/assets/images/login/setting_icon.png" />
				<span>알림 관리</span>
			</div>
		</div>
		<div class="search-content">
			<select class="list-select" v-model="searchCategory">
				<option value="">선택</option>
				<option value="참여자번호">참여자번호</option>
				<option value="참여자이름">참여자이름</option>
				<!-- <option value="데이터분류">데이터분류</option>
				<option value="상태">상태</option> -->
			</select>

			<div
				class="search-btn"
				style="position: relative; display: none;"
				:style="addSearchYn ? 'background-color: #0176F9;' : ''"
				@click.stop="openSearch($event);"
			>
				<img style="width: 14.65px; height: 13.84px; pointer-events: none;" src="@/assets/images/home/search_add.png"/>
				상세검색
			</div>
			<!-- 상세 검색 영역 -->
			<div
				class="add-search"
				:style="addSearchYn ? 'opacity: 1; visibility: visible; top:' + yPosistion + '; left:' + xPosistion + ';' : 'top:' + yPosistion + '; left:' + xPosistion + ';'"
			>
				<div class="min-title">상세 필터 검색</div>
				<div class="add-search-content">
					<div class="search-row">
						<div class="search-title-box">
							분만 예정일
						</div>
						<select class="list-select"></select>
					</div>
					<div class="search-row">
						<div class="search-title-box">
							분만 여부
						</div>
						<input class="input-crud" style="width: 240px;" type="text">
					</div>
				</div>
				<div class="btn-bottom">
					<button type="button" class="btn-save fright" title="Save" @click.stop="searchSave();">
						완료
					</button>
					<button type="button" class="btn-cancel fright" title="Cancel" @click.stop="searchClose();">
						취소
					</button>
				</div>
			</div>
			<input
				type="text"
				class="input-crud"
				style="width: 240px;"
				v-model="searchText"
				@keyup="keyupHandler"
			/>
			<div class="search-btn" @click.stop="selectAlarmList()">
				<img src="@/assets/images/home/search.png"/>
				검색
			</div>
			<div class="btn-right">
				<div class="add-btn" @click="doOpenCreate()">
					신규 등록
				</div>
			</div>
		</div>
		<div class="home-bottom" style="height: calc(100% - 165px);">
			<div class="content-box" style="width: 60%;">
				<div class="list-scroll-box scroll">
					<table class="tb-list-vertical" style="table-layout: fixed;">
						<colgroup>
							<col width="12%">
							<col width="16%">
							<col width="16%">
							<col width="10%">
							<col width="10%">
						</colgroup>
						<thead>
							<th>참여자 번호</th>
							<th>참여자 이름</th>
							<th>전화번호</th>
							<th>임신 주수</th>
							<th></th>
						</thead>
						<tbody>
							<template
								v-for="(patients) in alarmList"
							>
								<tr
									:key="patients.id + '0'"
									@click.stop="createChart(patients)"
									:class="openList.indexOf(patients.id) >= 0 ? 'openTr' : ''"
								>
									<td>{{patients.id}}</td>
									<td>{{patients.name != '' ? patients.name : '-'}}</td>
									<td>{{patients.phone != '' ? patients.phone : '-'}}</td>
									<td>{{setTodayWeeks(patients)}}</td>
									<td @click.stop="openPage(patients)"><img :style="openList.indexOf(patients.id) >= 0 ? 'transform: rotate(180deg);' : ''" style="width: 11.9px; height: 7px;" src="@/assets/images/home/table_arrow.png" /></td>
								</tr>
								<tr
									:key="patients.id + 'sub'"
									v-if="openList.indexOf(patients.id) >= 0 && patients.dataList.length > 0"
								>
								<td colspan="5">
											<table class="tb-list-vertical sub-table" style="table-layout: fixed;">
												<colgroup>
													<col width="12%">
													<col width="16%">
													<col width="16%">
													<col width="23%">
													<col width="23%">
												</colgroup>
												<thead>
													<th>상태</th>
													<th>데이터 분류</th>
													<th>수치</th>
													<th>측정 일시</th>
													<th>수신 일시</th>
												</thead>
												<tbody>
													<template
														v-for="(data, dataIndex) in patients.dataList"
													>
														<tr
															:key="dataIndex"	
															@click.stop="doOpenData(patients, data)"
														>
															<td><div class="status" :class="statusColor(data.status)">{{getStatusType(data.status)}}</div></td>
															<td>{{getRecordType(data.recordType)}}</td>
															<td v-if="data.recordType != 'PROTEINURIA'">{{data.recordType == 'SLEEP_TIME' ? getSleepTime(data.value) : data.recordType == 'BLOOD_PRESSURE' ? data.value + '/' + data.subValue : data.value}}</td>
															<td v-if="data.recordType == 'PROTEINURIA'">
																<span v-if="data.value == 1">0 mg/L</span>
																<span v-if="data.value == 2">15-30 mg/L</span>
																<span v-if="data.value == 3">30 mg/L</span>
																<span v-if="data.value == 4">100 mg/L</span>
																<span v-if="data.value == 5">300 mg/L</span>
																<span v-if="data.value == 6">1000 mg/L 이상</span>
															</td>
															<td>{{data.recordDetailDate.substring(0, 19)}}</td>
															<td>{{data.updateDate.substring(0, 19)}}</td>
														</tr>
													</template>
												</tbody>
											</table>
										</td>
									</tr>
							</template>
							<tr v-if="alarmList.length == 0">
								<td colspan="5" class="no-list">
									데이터가 존재하지 않습니다.
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div class="pagination-wrap">
					<pagination
						:data="pagination"
						:show-disabled="true"
						:limit="4"
						@pagination-change-page="doSearchPage"
					>
						<button type="button" slot="prev-nav" class="page-prev">&lt;</button>
						<button type="button" slot="next-nav" class="page-next">&gt;</button>
					</pagination>
				</div>
			</div>
			<div class="content-box" style="width: 40%;">
				<div class="chart-title">
					항목별 알림 횟수
				</div>
				<div style="height: calc(100% - 44px); padding: 20px;">
					<canvas ref="Chart"></canvas>
				</div>
			</div>
		</div>
		<SettingDetail v-if="isDataPopup" :selectData="selectData"/>
		<SettingCreate v-if="isCreatePopup"/>
	</div>
</template>

<script>
import Vue from "vue";
import VeeValidator from "vee-validate";
import EventBus from "@/script/EventBus.js";
import SettingDetail from "@/components/setting/SettingDetail.vue";
import SettingCreate from "@/components/setting/SettingCreate.vue";
import { Chart } from 'chart.js';
import axios from "axios";
let chart;
Vue.use(VeeValidator);

export default {
	name: "SettingList",
	created() {
		this.logger.debug(this, ".created()");
		console.log(this.userInfo.userId);
		this.selectAlarmList();
	},
	mounted() {
		this.logger.debug(this, ".mounted()");
		// this.createChart()
	},
	data() {
		return {
			items: {},
			isMode: 1,
			today: "",
			isDataPopup: false,
			isCreatePopup: false,
			alarmList: [],
			pagination: {},
			openList: [],
			selectdata: {},
			searchText: "",
			searchCategory: "",
			addSearchYn: false,
			xPosistion: "",
			yPosistion: "",
			options: {
				scales: {
					yAxes: [{
						ticks: {
							beginAtZero: true,
							// display: false
							stepSize : 2,
							max: 30,
						},
						stacked:true
					}],
					xAxes: [{
						ticks: {
							fontColor: 'rgba(9, 9, 9, 1)',
							fontSize: 12,
							fontFamily: 'Pretendard',
						},
						stacked:true
					}]
				},
				maintainAspectRatio: false,
				legend: {
					// display: false,
					labels: {
						fontSize: 12,
						fontStyle: 'bold',
						fontFamily: 'Pretendard',
						boxWidth: 13,
					},
				},
				
			}
		};
	},
	components: {
		SettingDetail,
		SettingCreate,
	},
	watch: {
		searchText: function(val) {
			// this.item.pageName = val;
			this.items.searchText = val;
			this.items.pageNum = 1;
		},
		searchCategory: function(val) {
			// this.item.pageName = val;
			this.items.searchCategory = val;
			this.items.pageNum = 1;
		}
	},
	methods: {
		createChart(patients){
			let label = [];
			let dataSetsData = [];
			let systemData = [];
			let emergencyData = [];

			axios
				.post(this.config.contextRoot + "/alarm/setAlarmList.do", patients)
				.then((response) => {
					console.log(response);
					patients.alarmList = response.data.alarmList;
					patients.emergencyList = response.data.emergencyList;
					patients.dataList = response.data.dataList;
					patients.managerList = response.data.managerList;

					if(patients.dataList.length > 0){
						var dataList = patients.dataList;

						for(var i = 0; i < dataList.length; i++){
							label.push(this.getRecordType(dataList[i].recordType));

							var count = 0;
							var sysCount = 0;
							var emerCount = 0;
							for(var j = 0; j < patients.alarmList.length; j++){
								if(patients.alarmList[j].recordType === dataList[i].recordType){
									if(patients.alarmList[j].systemYn == 'N'){
										count++;
									}
									else{
										sysCount++;
									}
								}
							}
							dataSetsData.push(count);
							systemData.push(sysCount);
							
							for(var k = 0; k < patients.emergencyList.length; k++){
								if(patients.emergencyList[k].recordType === dataList[i].recordType){
									emerCount++;
								}
							}
							emergencyData.push(emerCount);
						}
					}
					let data = {}
					data = {
						labels: label,
						datasets: [
							{
								label: '코디네이터 알림 횟수',
								barPercentage: 0.4,
								data: dataSetsData,
								backgroundColor: [
								'#0176F9',
								'#0176F9',
								'#0176F9',
								'#0176F9',
								'#0176F9',
								'#0176F9',
								'#0176F9',
								'#0176F9',
								'#0176F9',
								],
								borderColor: [
								'#0176F9',
								'#0176F9',
								'#0176F9',
								'#0176F9',
								'#0176F9',
								'#0176F9',
								'#0176F9',
								'#0176F9',
								'#0176F9',
								],
							},
							{
								label: '시스템 알림 횟수',
								barPercentage: 0.4,
								data: systemData,
								backgroundColor: [
								'#4BD985',
								'#4BD985',
								'#4BD985',
								'#4BD985',
								'#4BD985',
								'#4BD985',
								'#4BD985',
								'#4BD985',
								'#4BD985',
								],
								borderColor: [
								'#4BD985',
								'#4BD985',
								'#4BD985',
								'#4BD985',
								'#4BD985',
								'#4BD985',
								'#4BD985',
								'#4BD985',
								'#4BD985',
								],
							},
							{
								label: '응급 조치 횟수',
								barPercentage: 0.4,
								data: emergencyData,
								backgroundColor: [
								'#F94848',
								'#F94848',
								'#F94848',
								'#F94848',
								'#F94848',
								'#F94848',
								'#F94848',
								'#F94848',
								'#F94848',
								],
								borderColor: [
								'#F94848',
								'#F94848',
								'#F94848',
								'#F94848',
								'#F94848',
								'#F94848',
								'#F94848',
								'#F94848',
								'#F94848',
								],
							}
						]
					}
					if(chart !== undefined){
						chart.destroy();
					}

					chart = new Chart(this.$refs.Chart, {
						type:'bar',
						data:data,
						options:this.options,
					})
					chart.update();
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		keyupHandler(event) {
			this.logger.debug(this, "keyupHandler(event)");
			// this.searchTextVal = event.target.value;
			if (event.keyCode == 13)
			{
				EventBus.$emit("project-loading", true);
				this.selectAlarmList();
			}
		},
		selectAlarmList(){
			this.logger.debug(this, "selectAlarmList()");
			EventBus.$emit("project-loading", true);
			this.openProjectIndex = -1;
			axios
				.post(this.config.contextRoot + "/alarm/selectAlarmList.do", this.items)
				.then((response) => {
					console.log(response);
					this.alarmList = response.data.collectList;
					this.pagination = response.data.pagination;

					if(this.alarmList.length > 0){
						this.createChart(this.alarmList[0]);
					}

					EventBus.$emit("project-loading", false);
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doSearchPage(page) {
			this.logger.debug(this, "doSearchPage()");
			if (typeof page === "undefined" || page === 0) {
				page = 1;
			}
			this.items.pageNum = page;
			this.selectAlarmList();
		},
		openPage(patients) {
			this.logger.debug(this, "openPage()");

			if(patients.dataList.length < 1){
				axios
						.post(this.config.contextRoot + "/home/selectData.do", patients)
						.then((response) => {
							console.log(response);
	
							patients.dataList = response.data.dataList;
							patients.managerList = response.data.managerList;

						})
						.catch((error) => {
							this.exceptionHandler(this, error);
						});
			}

			let id = patients.id;
			let index = this.openList.indexOf(id);

			if(index >= 0) this.openList.splice(index, 1);
			else this.openList.push(id);
		},
		selectMode(code){
			if(code == 1){ this.isMode = 1;}
			else{this.isMode = 2;}
		},
		getDateValue() {
			var informedConsentDtTemp = this.items.informedConsentDtTemp;
			var informedConsentDt = this.items.informedConsentDt;

			if(this.utils.isEmpty(informedConsentDtTemp))
			{
				if(this.utils.isEmpty(informedConsentDt))
				{
					return "YYYY-MM-DD"
				}
				else
				{
					return informedConsentDt;
				}
			}
			else
			{
				{
					this.$set(this.items, "informedConsentDt", informedConsentDtTemp);
				}
				return this.items.informedConsentDt;
			}
		},
		clearDate() {
			this.$set(this.items, "informedConsentDt", "");
			this.$set(this.items, "informedConsentDtTemp", "");
			setTimeout(function() {
				let popup = document.getElementsByClassName("mx-datepicker-popup")[0];
				popup.style.display = "none";
			}.bind(this), 0);
		},
		doOpenData(patients, data) {
			this.logger.debug(this, "doOpenData()");

			if(patients.dataList.length < 1){
				EventBus.$emit("project-loading", true);
				axios
						.post(this.config.contextRoot + "/home/selectData.do", patients)
						.then((response) => {
							console.log(response);
	
							patients.dataList = response.data.dataList;
							patients.managerList = response.data.managerList;
							this.selectData = data;
							this.isDataPopup = true;
							EventBus.$emit("project-loading", false);

						})
						.catch((error) => {
							this.exceptionHandler(this, error);
						});
			}
			else{
				this.selectData = data;
				this.isDataPopup = true;
			}

			
		},
		doOpenCreate() {
			this.logger.debug(this, "doOpenCreate()");
			this.isCreatePopup = true;
		},
		openSearch(event){
			this.xPosistion = (event.clientX - event.offsetX) + "px";
			this.yPosistion = (event.clientY - event.offsetY - 32) + "px";
			if(this.addSearchYn === true){
				this.addSearchYn = false;
			}
			else{
				this.addSearchYn = true;
			}
		},
		searchSave(){
			if(this.addSearchYn === true){
				this.addSearchYn = false;
			}
			else{
				this.addSearchYn = true;
			}
		},
		searchClose(){
			if(this.addSearchYn === true){
				this.addSearchYn = false;
			}
			else{
				this.addSearchYn = true;
			}
		},
		statusColor(status){
			var result = "green";
			if(status == 'EMERGENCY'){
				result = 'red'
			}
			if(status == 'CAUTION'){
				result = 'yellow'
			}
			return result;
		},
		getRecordType(recordType){
			var result = "";

			if(recordType == 'WEIGHT'){
				result = '체중'
			}
			if(recordType == 'BLOOD_PRESSURE'){
				result = '혈압'
			}
			if(recordType == 'BLOOD_GLUCOSE'){
				result = '혈당'
			}
			if(recordType == 'HEART_RATE'){
				result = '심박수'
			}
			if(recordType == 'STEP_COUNT'){
				result = '걸음수'
			}
			if(recordType == 'CALORIE'){
				result = '칼로리'
			}
			if(recordType == 'PROTEINURIA'){
				result = '단백뇨'
			}
			if(recordType == 'OXYGEN_SATURATION'){
				result = '산소포화도'
			}
			if(recordType == 'STRESS'){
				result = '스트레스'
			}
			if(recordType == 'SLEEP_TIME'){
				result = '수면시간'
			}

			return result;
		},
		getStatusType(status){
			var result = "정상";
			if(status == 'EMERGENCY'){
				result = '경고'
			}
			if(status == 'CAUTION'){
				result = '주의'
			}
			return result;
		},
		getDataTotal(patients){
			var result = "";

			if(patients.dataList.length == 0){
				result = '0건';
			}
			else if(patients.dataList.length == 1){
				result = this.getRecordType(patients.dataList[0].recordType);
			}
			else{
				result = this.getRecordType( patients.dataList[0].recordType) + '외 ' + (patients.dataList.length-1) + '건';
			}
			return result;
		},
		setTodayWeeks(patients){
			var result = "";
			const rDate = new Date(patients.createDate.substring(0, 10));
			const date = new Date();
			const diff = date.getTime() - rDate.getTime();
			const resultDay = Math.abs(diff / (1000 * 60 * 60 * 24));
			result = parseInt(((resultDay)/7)) + parseInt(patients.weeks);
			if(isNaN(result)){
				result = 0;
			}
			return result + "주차";
		},
		getSleepTime(ms){
			var hour = String(Math.floor((ms / (1000*60*60)) % 24)).padStart(2, "0");
			var min = String(Math.floor((ms / (1000*60)) % 60)).padStart(2, "0");
			var sec = String(Math.floor((ms / (1000)) % 60)).padStart(2, "0");
			return hour+':'+min+':'+sec;
		}
	},
};
</script>
<style>
@import '../../assets/css/login/login.css';
.home-background{
	width: calc(100% - 360px);
	height: 100%;
}
.home-title{
	width: 100%;
	height: 29px;
	display: flex;
    justify-content: space-between;
}
.title-left{
	display: flex;
    align-items: center;
    column-gap: 12px;
	font-size: 24px;
	font-weight: bold;
}
.title-right{
	display: flex;
    align-items: center;
	font-size: 14px;
	column-gap: 20px;
}
.warn-dot{
	width: 16px;
	height: 16px;
	border-radius: 50px;
}
.font-red{
	color: #F94848;
}
.red{
	background-color: #F94848;
}
.yellow{
	background-color: #FFAD09;
}
.warn-wrap{
	display: flex;
	align-items: center;
    column-gap: 4px;
}
.home-top{
	width: 100%;
	height: 180px;
	display: flex;
	column-gap: 20px;
	margin: 20px 0;
}
.home-bottom{
	width: 100%;
	height: calc(100% - 269px);
	display: flex;
	column-gap: 20px;
	margin: 20px 0;
}
.content-box{
	width: 100%;
	border-radius: 8px;
	overflow: hidden;
	box-shadow: 0 0 10px 0px #ccc;
	background-color: #fff;
	position: relative;
}
.top-sub-title-red{
	width: 100%;
	height: 52px;
	background-color: #F94848;
	display: flex;
    align-items: center;
	justify-content: space-between;
    padding-left: 32px;
    color: #FFF;
	font-size: 20px;
}
.top-sub-title-green{
	width: 100%;
	height: 52px;
	background-color: #4BD985;
	display: flex;
    align-items: center;
	justify-content: space-between;
    padding-left: 32px;
    color: #FFF;
	font-size: 20px;
}
.count-dot{
	width: 8px;
	height: 8px;
	border: 1px solid #fff;
	border-radius: 50px;
}
.top-count{
	display: flex;
    column-gap: 5px;
	margin-right: 32px;
}
.white{
	background-color: #fff;
}
.none-content{
	width: 100%;
    height: calc(100% - 52px);
    display: flex;
    justify-content: center;
    align-items: center;
	font-size: 18px;
	color: #A9A9A9;
}
.left-btn{
	width: 31px;
	height: 38px;
	background-image: url(../../assets/images/home/left_btn.png);
	background-repeat: no-repeat;
	background-position: center;
	background-size: 31px 38px;
}
.right-btn{
	width: 31px;
	height: 38px;
	background-image: url(../../assets/images/home/right_btn.png);
	background-repeat: no-repeat;
	background-position: center;
	background-size: 31px 38px;
}
.name-tag{
	width: 44px;
	height: 22px;
	background-color: #EFEFEF;
	border-radius: 11px;
	font-size: 14px;
	color: #A9A9A9;
	display: flex;
    justify-content: center;
    align-items: center;
}
.data-zone{
	display: flex;
    justify-content: flex-start;
	align-items: center;
	column-gap: 10px;
	font-size: 16px;
	font-weight: bold;
}
.dot-line{
	height: 64px;
	border: 1px solid #DDDDDD;
	border-style: dashed;
}
.top-data{
	display: flex;
    flex-direction: column;
    align-items: flex-start;
    row-gap: 4px;
}
.table-name{
	font-size: 20px;
	font-weight: bold;
	width: 100%;
	height: 60px;
	display: flex;
    align-items: center;
    justify-content: flex-start;
    column-gap: 10px;
    padding-left: 32px;
}
.table-btn{
	width: 66px;
	height: 29px;
	border-radius: 15px;
	font-size: 16px;
	font-weight: 600;
	color: #6D6D6D;
}
.table-btn:hover{
	color: #FFF;
	background-color: #555555;
}
.btn-on{
	color: #FFF;
	background-color: #555555;
}
.list-select{
	width: 240px;
	height: 40px;
    padding: 0 15px;
    border: 1px solid #A9A9A9;
	border-radius: 5px;
    font-size: 10pt;
    color: #090909;
	
}
.search-content{
	display: flex;
    align-items: center;
	column-gap: 10px;
	margin: 25px 0;
	padding-bottom: 25px;
    border-bottom: 1px solid #BDC1C6;
}
.search-btn{
	min-width: 100px;
	height: 40px;
	border-radius: 5px;
	background-color: #555555;
	color: #fff;
	display: flex;
    justify-content: center;
    align-items: center;
	column-gap: 8px;
	cursor: pointer;
	font-size: 16px;
}
.search-btn:hover{
	background-color: #0176F9;
}
.search-btn > img{
	width: 13.5px;
	height: 14.5px;
}
.status{
	min-width: 55px;
	width: 55px;
	height: 22px;
	border-radius: 12px;
	color: #fff;
	font-size: 14px;
	display: flex;
	justify-content: center;
    align-items: center;
}
.add-search{
	visibility: hidden;
	opacity: 0;
	width: 430px;
	height: fit-content;
	position: absolute;
	background-color: #fff;
	box-shadow: 0 0 10px 0px #ccc;
	border-radius: 8px;
	color: #2A2A2A;
	transition: all 0.2s ease;
}
.min-title{
	font-size: 18px;
	font-weight: bold;
	padding: 14px 20px;
	border-bottom: 1px solid #DDDDDD;
}
.search-title-box{
	width: 140px;
	height: 40px;
	border-radius: 5px;
	background-color: #EEEEEE;
	display: flex;
    justify-content: center;
    align-items: center;
	font-size: 16px;
	font-weight: bold;
}
.search-row{
	display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 10px;
}
.add-search-content{
	padding: 17px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 8px;
}
.btn-bottom{
	height: 40px;
	display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 8px;
	margin-bottom: 28px;
}
.btn-bottom > button{
	height: 40px;
	width: 100px;
	max-width: 100px;
	min-width: 100px;
}
.hidden{
	display: none;
}
.add-btn{
	float: right;
	min-width: 113px;
	height: 40px;
	border: 1px solid #0176F9;
	border-radius: 5px;
	background-color: #fff;
	color: #0176F9;
	display: flex;
    justify-content: center;
    align-items: center;
	column-gap: 8px;
	cursor: pointer;
	font-size: 16px;
}
.add-btn:hover{
	background-color: #0176F9;
	color:#fff;
}
.excel-btn{
	float: right;
	min-width: 113px;
	height: 40px;
	border: 1px solid #555F6D;
	border-radius: 5px;
	background-color: #fff;
	color: #555F6D;
	display: flex;
    justify-content: center;
    align-items: center;
	column-gap: 8px;
	cursor: pointer;
	font-size: 16px;
}
.excel-btn:hover{
	background-color: #555F6D;
	color:#fff;
}
.btn-right{
	margin-left: auto;
    display: flex;
    flex-direction: row;
    column-gap: 10px;
}
.chart-title{
	width: 100%;
	height: 44px;
	background-color: #EEEEEE;
	border-bottom: 1px solid #DDD;
	font-size: 16px;
	font-weight: bold;
	color: #090909;
	display: flex;
    align-items: center;
	padding: 0 23px;
	overflow: hidden;
}
</style>
import { of } from "core-js/core/array";
import { userSetter } from "core-js/fn/symbol";

